// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"DataTable_dataTable__1qTos","rowAction":"DataTable_rowAction__2UCWm","clickable":"DataTable_clickable__YIlCl"};